module.exports = "/_next/static/images/20a70942ef1dd836c907771a21ae309f-apple-pay-mini.png";